import API_BASE from "../config.js";
import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import { Dica, BotaoDica } from "../components/Dica";
import Modal from "../components/Modal";
import { authFetch } from "../services/authFetch";
import { useTranslation } from "react-i18next";

// REGISTROS RECUPERADOS
//
// O QUE E
// A janela para o arquivo que a blindagem de 14/09/2026 vem enchendo em
// silencio. Toda exclusao de O.S., cliente, agendamento, estoque ou
// lancamento financeiro copia a linha inteira para `registros_excluidos`
// ANTES do DELETE.
//
// AS REGRAS QUE ESTA TELA RESPEITA
// 1. Nada e apagado. "Excluir" aqui e OCULTAR: o registro sai da lista e
//    continua no banco, e o botao "Mostrar ocultos" traz de volta. Este
//    arquivo e a ultima linha de defesa contra perda de dado.
// 2. So registro de RECUPERACAO MANUAL pode ser editado. O que a preservacao
//    automatica guardou vale por ser copia fiel do que foi excluido.
// 3. Recriar gera numero NOVO. O numero antigo pode pertencer a outra O.S.
//    hoje -- foi exatamente esse o acidente que originou esta tela.

function getTenantId() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1");
  } catch {
    return sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id") || "1";
  }
}

function getConfigKey() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return "saas_config";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return "saas_config_tenant_" + (payload.tenant_id || "1");
  } catch { return "saas_config"; }
}

const ORIGENS = [
  { valor: "", rotulo: "Tudo" },
  { valor: "ordens_servico", rotulo: "O.S." },
  { valor: "clientes", rotulo: "Clientes" },
  { valor: "agendamentos", rotulo: "Agendamentos" },
  { valor: "estoque", rotulo: "Estoque" },
  { valor: "financeiro", rotulo: "Financeiro" },
];

const COR_ORIGEM = {
  ordens_servico: "#3b82f6",
  clientes: "#8b5cf6",
  agendamentos: "#f59e0b",
  estoque: "#14b8a6",
  financeiro: "#22c55e",
};

function rotuloOrigem(tabela) {
  const achado = ORIGENS.find((o) => o.valor === tabela);
  return achado ? achado.rotulo : tabela;
}

function moeda(v) {
  const n = Number(v) || 0;
  return "R$ " + n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function quando(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return String(iso); }
}

// Busca rapida: mesma ideia da busca de Clientes -- acento nao atrapalha, e
// digitar so numeros acha telefone e placa mesmo com mascara.
const semAcento = (s) => String(s == null ? "" : s)
  .normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
const soDigitos = (s) => String(s == null ? "" : s).replace(/\D/g, "");
const semSeparador = (s) => String(s == null ? "" : s).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

function casa(registro, termo) {
  const t = semAcento(termo);
  if (!t) return true;
  // busca_extra traz telefone, documento e e-mail -- campos que a lista nao
  // mostra, mas que sao os primeiros que alguem digita para achar alguem.
  const texto = semAcento([registro.titulo, registro.subtitulo, registro.veiculo,
                           registro.registro_id, registro.excluido_por,
                           registro.busca_extra].join(" "));
  if (texto.includes(t)) return true;
  const dig = soDigitos(termo);
  if (dig.length >= 3 && soDigitos([registro.subtitulo, registro.titulo,
                                    registro.busca_extra].join(" ")).includes(dig)) return true;
  const chave = semSeparador(termo);
  if (chave.length >= 3 && semSeparador([registro.subtitulo, registro.registro_id].join(" ")).includes(chave)) return true;
  return false;
}

function comoObjeto(v) {
  if (!v) return null;
  if (typeof v === "object") return v;
  try { return JSON.parse(v); } catch { return null; }
}

function itensDoRegistro(dados) {
  if (!dados) return [];
  const orc = comoObjeto(dados.orcamento);
  if (orc && Array.isArray(orc.itens) && orc.itens.length > 0) return orc.itens;
  const serv = comoObjeto(dados.servicos);
  if (Array.isArray(serv)) return serv;
  return Array.isArray(dados.servicos) ? dados.servicos : [];
}

const CAMPOS_OCULTOS = ["orcamento", "servicos", "veiculos", "id", "tenant_id", "_recuperacao"];

// Campos que a edicao oferece. Lista fechada de proposito: editar um
// registro de arquivo e para COMPLETAR o que faltou na reconstrucao, nao
// para reescrever o registro inteiro.
const CAMPOS_EDITAVEIS = [
  ["cliente", "Cliente"],
  ["telefone", "Telefone"],
  ["cpf", "CPF/CNPJ"],
  ["placa", "Placa"],
  ["veiculo", "Veiculo"],
  ["km", "KM"],
  ["tecnico", "Responsavel"],
  ["status", "Status"],
  ["criada", "Data do servico"],
  ["relato_cliente", "Relato do cliente"],
  ["obs", "Observacoes"],
];

function escapar(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

// O documento sai numa janela propria. window.print() direto imprimiria o
// painel inteiro; assim sai so o documento, e o navegador oferece "Salvar
// como PDF" na propria caixa de impressao.
function imprimirDocumento(registro, cfg) {
  const d = registro.dados || {};
  const itens = itensDoRegistro(d);
  const total = itens.length
    ? itens.reduce((a, i) => a + (Number(i && i.preco) || 0), 0)
    : Number(d.total) || 0;
  const cor = (cfg && cfg.corDocumento) || "#1e40af";
  const linhas = itens.map((it, i) => (
    '<tr style="background:' + (i % 2 === 0 ? "#f8fafc" : "#fff") + '">' +
    '<td>' + escapar((it && it.nome) || "") + '</td>' +
    '<td style="text-align:center">' + escapar((it && it.qtd) || 1) + '</td>' +
    '<td style="text-align:right">' + moeda(it && it.preco) + '</td>' +
    '</tr>'
  )).join("");

  const reemissao = registro.recuperacao_manual
    ? '<p class="nota">Documento reemitido em ' + escapar(new Date().toLocaleDateString("pt-BR")) +
      ' a partir do registro de ' + escapar(d.criada || "—") + '.</p>'
    : "";

  const html =
    '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + escapar(registro.registro_id) + '</title>' +
    '<style>' +
    'body{font-family:Arial,Helvetica,sans-serif;color:#1e293b;margin:32px}' +
    'h1{color:' + cor + ';font-size:22px;margin:0}' +
    '.sub{color:#64748b;font-size:12px;margin-top:2px}' +
    '.topo{display:flex;justify-content:space-between;align-items:flex-start;' +
    'border-bottom:2px solid #e2e8f0;padding-bottom:16px;margin-bottom:20px}' +
    '.selo{background:' + cor + ';color:#fff;border-radius:8px;padding:4px 14px;font-size:13px;font-weight:700}' +
    '.blocos{display:flex;gap:16px;margin-bottom:20px}' +
    '.bloco{background:#f8fafc;border-radius:8px;padding:12px;flex:1}' +
    '.rot{color:#64748b;font-size:10px;font-weight:700;text-transform:uppercase;margin-bottom:4px}' +
    'table{border-collapse:collapse;width:100%;margin-bottom:16px}' +
    'th{background:' + cor + ';color:#fff;font-size:12px;padding:9px 12px;text-align:left}' +
    'td{border-bottom:1px solid #e2e8f0;font-size:13px;padding:8px 12px}' +
    '.total{text-align:right;font-size:18px;font-weight:800;color:' + cor + '}' +
    '.nota{color:#64748b;font-size:11px;border-top:1px solid #e2e8f0;padding-top:10px;margin-top:22px}' +
    '.ass{display:flex;gap:40px;margin-top:44px}' +
    '.ass div{flex:1;border-top:1px solid #94a3b8;padding-top:6px;text-align:center;color:#64748b;font-size:12px}' +
    '</style></head><body>' +
    '<div class="topo"><div>' +
    ((cfg && cfg.logo) ? '<img src="' + escapar(cfg.logo) + '" style="height:70px;display:block;margin-bottom:8px" alt="">' : "") +
    '<h1>' + escapar((cfg && cfg.nome) || "SAAS.GL") + '</h1>' +
    '<div class="sub">' + escapar(registro.registro_id) + '</div>' +
    '</div><div style="text-align:right">' +
    '<div class="selo">COMPROVANTE DE SERVICO</div>' +
    '<div class="sub">' + escapar(d.criada || "") + '</div>' +
    '</div></div>' +
    '<div class="blocos">' +
    '<div class="bloco"><div class="rot">Cliente</div><b>' + escapar(d.cliente || "—") + '</b>' +
    (d.telefone ? '<div class="sub">' + escapar(d.telefone) + '</div>' : "") + '</div>' +
    '<div class="bloco"><div class="rot">Veiculo</div><b>' + escapar(d.veiculo || "—") + '</b>' +
    '<div class="sub">' + escapar(d.placa || "") + (d.km ? " · " + escapar(d.km) + " km" : "") + '</div></div>' +
    (d.tecnico ? '<div class="bloco"><div class="rot">Responsavel</div><b>' + escapar(d.tecnico) + '</b></div>' : "") +
    '</div>' +
    (itens.length
      ? '<table><thead><tr><th>Descricao</th><th style="text-align:center">Qtd</th>' +
        '<th style="text-align:right">Valor</th></tr></thead><tbody>' + linhas + '</tbody></table>'
      : "") +
    '<div class="total">Total: ' + moeda(total) + '</div>' +
    (d.relato_cliente ? '<p class="nota"><b>Relato do cliente:</b> ' + escapar(d.relato_cliente) + '</p>' : "") +
    (d.obs ? '<p class="nota"><b>Observacoes:</b> ' + escapar(d.obs) + '</p>' : "") +
    '<div class="ass"><div>Assinatura do responsavel</div><div>Assinatura do cliente</div></div>' +
    reemissao +
    '</body></html>';

  const w = window.open("", "_blank", "width=900,height=700");
  if (!w) return false;
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { /* o usuario imprime pelo menu */ } }, 400);
  return true;
}

export default function Recuperados() {
  const { t } = useTranslation();
  const tenantId = getTenantId();
  const cfg = (() => {
    try { return JSON.parse(localStorage.getItem(getConfigKey()) || "{}"); } catch { return {}; }
  })();

  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");
  const [origem, setOrigem] = useState("");
  const [busca, setBusca] = useState("");
  const [verOcultos, setVerOcultos] = useState(false);

  const [aberto, setAberto] = useState(null);
  const [carregandoItem, setCarregandoItem] = useState(false);
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [aviso, setAviso] = useState("");

  const carregar = useCallback(() => {
    setCarregando(true);
    setErro("");
    const qs = [];
    if (origem) qs.push("tabela=" + encodeURIComponent(origem));
    if (verOcultos) qs.push("incluir_ocultos=true");
    const url = API_BASE + "/api/v1/dados/registros-excluidos/" + tenantId + (qs.length ? "?" + qs.join("&") : "");
    authFetch(url, {})
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("falha"))))
      .then((d) => { setLista(Array.isArray(d) ? d : []); setCarregando(false); })
      .catch(() => {
        setLista([]);
        setCarregando(false);
        setErro(t("recuperados.erro_carregar", "Nao foi possivel carregar o arquivo agora."));
      });
  }, [tenantId, origem, verOcultos, t]);

  useEffect(() => { carregar(); }, [carregar]);

  const abrir = (item) => {
    setCarregandoItem(true);
    setEditando(null);
    setAviso("");
    setAberto({ ...item, dados: null });
    authFetch(API_BASE + "/api/v1/dados/registros-excluidos/" + tenantId + "/" + item.id, {})
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("falha"))))
      .then((d) => { setAberto(d); setCarregandoItem(false); })
      .catch(() => {
        setCarregandoItem(false);
        setAberto((a) => (a ? { ...a, _erro: true } : a));
      });
  };

  const patch = (corpo, depois) => {
    if (!aberto) return;
    setSalvando(true);
    authFetch(API_BASE + "/api/v1/dados/registros-excluidos/" + tenantId + "/" + aberto.id, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(corpo),
    })
      .then(async (r) => {
        if (!r.ok) {
          const e = await r.json().catch(() => ({}));
          throw new Error(e.detail || "falha");
        }
        setSalvando(false);
        if (depois) depois();
        carregar();
      })
      .catch((e) => { setSalvando(false); setAviso(e.message || "Nao foi possivel salvar."); });
  };

  const ocultar = (valor) => {
    patch({ oculto: valor }, () => {
      setAviso(valor
        ? t("recuperados.ocultado", "Registro ocultado. Ele continua guardado — use \"Mostrar ocultos\" para reve-lo.")
        : t("recuperados.reexibido", "Registro de volta na lista."));
      setAberto((a) => (a ? { ...a, oculto: valor } : a));
    });
  };

  const salvarEdicao = () => {
    patch({ dados: editando }, () => {
      setAviso(t("recuperados.editado_ok", "Registro atualizado."));
      setEditando(null);
      abrir({ id: aberto.id });
    });
  };

  const recriar = () => {
    if (!aberto) return;
    if (!window.confirm(t("recuperados.confirm_recriar",
      "Recriar como O.S. ativa? Ela recebe um NUMERO NOVO no fim da fila — o numero antigo pode pertencer a outra O.S. hoje. O registro do arquivo continua aqui."))) return;
    setSalvando(true);
    authFetch(API_BASE + "/api/v1/dados/registros-excluidos/" + tenantId + "/" + aberto.id + "/recriar-os", {
      method: "POST", headers: { "Content-Type": "application/json" }, body: "{}",
    })
      .then(async (r) => {
        const corpo = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(corpo.detail || "falha");
        setSalvando(false);
        setAviso(t("recuperados.recriada", "Recriada como ") + corpo.id + ".");
        setAberto((a) => (a ? { ...a, recriado_como: corpo.id } : a));
        carregar();
      })
      .catch((e) => { setSalvando(false); setAviso(e.message || "Nao foi possivel recriar."); });
  };

  const filtrada = lista.filter((r) => casa(r, busca));
  const itens = aberto && aberto.dados ? itensDoRegistro(aberto.dados) : [];
  const totalItens = itens.reduce((a, i) => a + (Number(i && i.preco) || 0), 0);
  const ehOS = aberto && aberto.tabela === "ordens_servico";

  const btn = (cor, fundo) => ({
    background: fundo, border: "1px solid " + cor, borderRadius: 8, color: cor,
    cursor: "pointer", fontSize: 12, fontWeight: 700, padding: "8px 14px", whiteSpace: "nowrap",
  });

  return (
    <Layout>
      <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>

        <div>
          <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{ fontSize: 22, fontWeight: 700 }}>{t("recuperados.titulo", "Registros Recuperados")}</h1><BotaoDica id="recuperados" /></div>
          <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 3 }}>
            {t("recuperados.subtitulo", "Tudo que foi excluido fica guardado aqui, com o conteudo completo. Nada nesta tela apaga um registro.")}
          </p>
        </div>

        <Dica id="recuperados" jaUsou={lista.length > 0} texto={t("dicas.recuperados")} />

        <div style={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 8 }}>
          {ORIGENS.map((o) => (
            <button key={o.valor || "tudo"} onClick={() => setOrigem(o.valor)}
              style={{
                background: origem === o.valor ? "var(--accent)" : "var(--bg4)",
                border: "none", borderRadius: 20,
                color: origem === o.valor ? "#fff" : "var(--text2)",
                cursor: "pointer", fontSize: 11.5, fontWeight: 600, padding: "5px 13px",
              }}>
              {o.rotulo}
            </button>
          ))}
          <input id="recuperados-busca" value={busca} onChange={(e) => setBusca(e.target.value)}
            placeholder={t("recuperados.busca_placeholder", "Buscar por nome, placa, telefone ou numero")}
            style={{ flex: 1, fontSize: 13, minWidth: 200 }} />
          <label style={{ alignItems: "center", color: "var(--text2)", cursor: "pointer", display: "flex", fontSize: 11.5, gap: 6, whiteSpace: "nowrap" }}>
            <input type="checkbox" checked={verOcultos} onChange={(e) => setVerOcultos(e.target.checked)} />
            {t("recuperados.mostrar_ocultos", "Mostrar ocultos")}
          </label>
          <span style={{ color: "var(--text3)", fontSize: 11.5, whiteSpace: "nowrap" }}>
            {filtrada.length} {filtrada.length === 1 ? "registro" : "registros"}
          </span>
        </div>

        {erro && (
          <div style={{ background: "#ef444415", border: "1px solid #ef4444", borderRadius: 8, color: "#ef4444", fontSize: 13, padding: "10px 14px" }}>
            {erro}
          </div>
        )}

        {carregando ? (
          <div style={{ color: "var(--text3)", fontSize: 13, padding: "40px 0", textAlign: "center" }}>
            {t("recuperados.carregando", "Carregando o arquivo...")}
          </div>
        ) : filtrada.length === 0 ? (
          <div style={{ background: "var(--bg3)", border: "1px dashed var(--border)", borderRadius: 12, color: "var(--text3)", fontSize: 13, padding: "44px 20px", textAlign: "center" }}>
            {busca || origem
              ? t("recuperados.vazio_filtro", "Nenhum registro com esse filtro.")
              : t("recuperados.vazio", "Nada foi excluido ate agora. Quando algo for, aparece aqui com o conteudo completo.")}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {filtrada.map((r) => (
              <div key={r.id} onClick={() => abrir(r)}
                style={{
                  alignItems: "center", background: "var(--bg3)", border: "1px solid var(--border)",
                  borderLeft: "3px solid " + (COR_ORIGEM[r.tabela] || "var(--border)"),
                  borderRadius: 10, cursor: "pointer", display: "flex", gap: 14,
                  justifyContent: "space-between", opacity: r.oculto ? 0.55 : 1, padding: "12px 16px",
                }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 8 }}>
                    <span style={{
                      background: (COR_ORIGEM[r.tabela] || "#64748b") + "22", borderRadius: 4,
                      color: COR_ORIGEM[r.tabela] || "var(--text3)", fontSize: 9.5, fontWeight: 700,
                      letterSpacing: "0.06em", padding: "2px 7px", textTransform: "uppercase",
                    }}>{rotuloOrigem(r.tabela)}</span>
                    <span style={{ color: "var(--accent2)", fontFamily: "monospace", fontSize: 11.5, fontWeight: 700 }}>{r.registro_id}</span>
                    <span style={{ fontSize: 13.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {r.titulo || "—"}
                    </span>
                    {r.recuperacao_manual && (
                      <span style={{ background: "#b4530922", borderRadius: 4, color: "#d97706", fontSize: 9, fontWeight: 700, padding: "1px 6px", textTransform: "uppercase" }}>
                        {t("recuperados.selo_manual", "recuperado a mao")}
                      </span>
                    )}
                    {r.recriado_como && (
                      <span style={{ background: "#22c55e22", borderRadius: 4, color: "#22c55e", fontSize: 9, fontWeight: 700, padding: "1px 6px", textTransform: "uppercase" }}>
                        {t("recuperados.selo_recriado", "virou")} {r.recriado_como}
                      </span>
                    )}
                    {r.oculto && (
                      <span style={{ background: "#64748b22", borderRadius: 4, color: "var(--text3)", fontSize: 9, fontWeight: 700, padding: "1px 6px", textTransform: "uppercase" }}>
                        {t("recuperados.selo_oculto", "oculto")}
                      </span>
                    )}
                  </div>
                  <div style={{ color: "var(--text3)", fontSize: 11.5, marginTop: 3 }}>
                    {[r.subtitulo, r.veiculo, r.data_original].filter(Boolean).join(" · ") || "—"}
                  </div>
                  <div style={{ color: "var(--text3)", fontSize: 10.5, marginTop: 2 }}>
                    {t("recuperados.excluido_em", "Excluido em")} {quando(r.excluido_em)}
                    {r.excluido_por ? " · " + r.excluido_por : ""}
                    {r.editado_em ? " · " + t("recuperados.editado_em", "editado em") + " " + quando(r.editado_em) : ""}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  {Number(r.valor) > 0 && (
                    <div style={{ color: "#22c55e", fontSize: 14, fontWeight: 700 }}>{moeda(r.valor)}</div>
                  )}
                  <div style={{ color: "var(--text3)", fontSize: 11 }}>{t("recuperados.ver", "ver")}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {aberto && (
        <Modal onClose={() => { setAberto(null); setEditando(null); }} largura={880}>
          <div style={{ alignItems: "flex-start", display: "flex", gap: 12, justifyContent: "space-between", marginBottom: 16 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "var(--text3)", fontSize: 10.5, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
                {rotuloOrigem(aberto.tabela)} · {t("recuperados.preservado", "registro preservado")}
              </div>
              <div style={{ fontSize: 19, fontWeight: 800, marginTop: 2 }}>
                {aberto.registro_id}{aberto.titulo ? " — " + aberto.titulo : ""}
              </div>
              <div style={{ color: "var(--text3)", fontSize: 11.5, marginTop: 3 }}>
                {t("recuperados.excluido_em", "Excluido em")} {quando(aberto.excluido_em)}
                {aberto.excluido_por ? " · " + aberto.excluido_por : ""}
              </div>
              {aberto.editado_em && (
                <div style={{ color: "#d97706", fontSize: 11, marginTop: 2 }}>
                  {t("recuperados.editado_aviso", "Completado a mao em")} {quando(aberto.editado_em)}
                  {aberto.editado_por ? " por " + aberto.editado_por : ""}
                </div>
              )}
            </div>
            <button onClick={() => { setAberto(null); setEditando(null); }}
              style={{ background: "var(--bg4)", border: "1px solid var(--border)", borderRadius: 8, color: "var(--text2)", cursor: "pointer", fontSize: 13, padding: "6px 12px" }}>
              {t("common.fechar", "Fechar")}
            </button>
          </div>

          {aviso && (
            <div style={{ background: "#3b82f615", border: "1px solid #3b82f6", borderRadius: 8, color: "var(--text)", fontSize: 12.5, marginBottom: 14, padding: "9px 13px" }}>
              {aviso}
            </div>
          )}

          {carregandoItem ? (
            <div style={{ color: "var(--text3)", fontSize: 13, padding: "30px 0", textAlign: "center" }}>
              {t("recuperados.carregando_item", "Abrindo o registro...")}
            </div>
          ) : aberto._erro ? (
            <div style={{ color: "#ef4444", fontSize: 13 }}>
              {t("recuperados.erro_item", "Nao foi possivel abrir este registro agora.")}
            </div>
          ) : aberto.dados ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

              <div style={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 8 }}>
                <button onClick={() => { if (!imprimirDocumento(aberto, cfg)) setAviso(t("recuperados.popup_bloqueado", "O navegador bloqueou a janela. Libere o pop-up para este site e tente de novo.")); }}
                  style={btn("#16a34a", "#16a34a22")}>
                  {t("recuperados.btn_pdf", "Documento / PDF")}
                </button>

                {aberto.recuperacao_manual && !editando && (
                  <button onClick={() => {
                    const inicial = {};
                    CAMPOS_EDITAVEIS.forEach(([k]) => { inicial[k] = aberto.dados[k] == null ? "" : String(aberto.dados[k]); });
                    setEditando(inicial);
                  }} style={btn("#3b82f6", "#3b82f622")}>
                    {t("recuperados.btn_editar", "Editar")}
                  </button>
                )}

                {ehOS && !aberto.recriado_como && (
                  <button onClick={recriar} disabled={salvando} style={btn("#8b5cf6", "#8b5cf622")}>
                    {t("recuperados.btn_recriar", "Recriar como O.S. ativa")}
                  </button>
                )}
                {ehOS && aberto.recriado_como && (
                  <span style={{ color: "#22c55e", fontSize: 12, fontWeight: 700 }}>
                    {t("recuperados.ja_recriada", "Ja recriada como")} {aberto.recriado_como}
                  </span>
                )}

                <div style={{ flex: 1 }} />

                <button onClick={() => ocultar(!aberto.oculto)} disabled={salvando}
                  style={btn(aberto.oculto ? "#22c55e" : "#ef4444", aberto.oculto ? "#22c55e15" : "#ef444415")}>
                  {aberto.oculto
                    ? t("recuperados.btn_reexibir", "Trazer de volta")
                    : t("recuperados.btn_ocultar", "Ocultar da lista")}
                </button>
              </div>

              {editando ? (
                <div style={{ background: "var(--bg3)", border: "1px solid #3b82f6", borderRadius: 10, padding: 16 }}>
                  <div style={{ color: "var(--text2)", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", marginBottom: 12, textTransform: "uppercase" }}>
                    {t("recuperados.completar", "Completar o registro")}
                  </div>
                  <div style={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fit,minmax(190px,1fr))" }}>
                    {CAMPOS_EDITAVEIS.map(([k, rotulo]) => (
                      <div key={k}>
                        <label htmlFor={"rec-" + k} style={{ color: "var(--text3)", display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.05em", marginBottom: 3, textTransform: "uppercase" }}>
                          {rotulo}
                        </label>
                        <input id={"rec-" + k} value={editando[k] || ""}
                          onChange={(e) => setEditando((f) => ({ ...f, [k]: e.target.value }))}
                          style={{ fontSize: 13, width: "100%" }} />
                      </div>
                    ))}
                  </div>
                  <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
                    <button onClick={salvarEdicao} disabled={salvando} style={btn("#22c55e", "#22c55e22")}>
                      {salvando ? t("common.salvando", "Salvando...") : t("common.salvar", "Salvar")}
                    </button>
                    <button onClick={() => setEditando(null)} style={btn("var(--text2)", "var(--bg4)")}>
                      {t("common.cancelar", "Cancelar")}
                    </button>
                  </div>
                  <div style={{ color: "var(--text3)", fontSize: 11, marginTop: 10 }}>
                    {t("recuperados.editar_aviso", "A edicao fica registrada com seu usuario e a data, e aparece na lista.")}
                  </div>
                </div>
              ) : (
                <div style={{ background: "var(--bg3)", borderRadius: 10, display: "grid", gap: 12, gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", padding: 16 }}>
                  {Object.keys(aberto.dados)
                    .filter((k) => !CAMPOS_OCULTOS.includes(k))
                    .filter((k) => {
                      const v = aberto.dados[k];
                      return v !== null && v !== undefined && String(v).trim() !== "";
                    })
                    .map((k) => (
                      <div key={k}>
                        <div style={{ color: "var(--text3)", fontSize: 9.5, fontWeight: 700, letterSpacing: "0.06em", marginBottom: 2, textTransform: "uppercase" }}>
                          {k.replace(/_/g, " ")}
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 600, overflowWrap: "anywhere" }}>
                          {String(aberto.dados[k])}
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {itens.length > 0 && !editando && (
                <div>
                  <div style={{ color: "var(--text2)", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", marginBottom: 8, textTransform: "uppercase" }}>
                    {t("recuperados.itens", "Itens")} ({itens.length})
                  </div>
                  <div style={{ border: "1px solid var(--border)", borderRadius: 10, overflow: "hidden" }}>
                    {itens.map((it, i) => (
                      <div key={i} style={{
                        alignItems: "center", background: i % 2 === 0 ? "var(--bg3)" : "transparent",
                        borderBottom: "1px solid var(--border)", display: "flex", fontSize: 13,
                        gap: 12, justifyContent: "space-between", padding: "9px 14px",
                      }}>
                        <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {(it && it.nome) || "—"}
                        </span>
                        <span style={{ color: "var(--text3)", fontSize: 11.5, whiteSpace: "nowrap" }}>
                          {t("recuperados.qtd", "qtd")} {(it && it.qtd) || 1}
                        </span>
                        <span style={{ fontWeight: 700, whiteSpace: "nowrap" }}>{moeda(it && it.preco)}</span>
                      </div>
                    ))}
                    <div style={{ alignItems: "center", display: "flex", justifyContent: "space-between", padding: "11px 14px" }}>
                      <span style={{ fontSize: 13, fontWeight: 700 }}>{t("recuperados.total", "Total")}</span>
                      <span style={{ color: "#22c55e", fontSize: 17, fontWeight: 800 }}>{moeda(totalItens)}</span>
                    </div>
                  </div>
                </div>
              )}

              {aberto.dados._recuperacao && (
                <div style={{ background: "#b4530912", border: "1px solid #b4530955", borderRadius: 8, color: "var(--text2)", fontSize: 11.5, lineHeight: 1.6, padding: "10px 14px" }}>
                  <b style={{ color: "#d97706" }}>{t("recuperados.origem", "Origem deste registro")}: </b>
                  {String(aberto.dados._recuperacao)}
                </div>
              )}

              <div style={{ background: "var(--bg3)", border: "1px dashed var(--border)", borderRadius: 8, color: "var(--text3)", fontSize: 11.5, lineHeight: 1.6, padding: "10px 14px" }}>
                {t("recuperados.aviso_nao_apaga", "Ocultar tira o registro da lista, mas nao apaga nada: ele continua guardado e volta pelo filtro \"Mostrar ocultos\".")}
              </div>
            </div>
          ) : null}
        </Modal>
      )}
    </Layout>
  );
}
